module.exports = __webpack_public_path__ + "static/media/xoleg_severe_left.20cdb53e.png";